import React, { useEffect, useState } from "react";

interface LoadingCounterProps {
  count: number; // تعداد شماره‌شماری
  text: string; // متنی که بعد از لودینگ نمایش داده می‌شود
}

const LoadingCounter: React.FC<LoadingCounterProps> = ({ count, text }) => {
  const [currentCount, setCurrentCount] = useState<number>(0); // شمارنده فعلی
  const [isLoading, setIsLoading] = useState<boolean>(true); // وضعیت لودینگ

  useEffect(() => {
    if (isLoading && currentCount < count) {
      const timer = setTimeout(() => {
        setCurrentCount((prev) => prev + 1);
      }, 500); // فاصله زمانی بین شماره‌شماری (500 میلی‌ثانیه)
      return () => clearTimeout(timer);
    } else if (currentCount >= count) {
      setIsLoading(false); // پایان لودینگ
    }
  }, [currentCount, count, isLoading]);

  return (
    <div className="flex flex-col mt-50 items-center justify-center gap-4">
      {isLoading ? (
        <div className="flex flex-col items-center">
          <div className="loader border-t-4 border-b-4 border-blue-500 w-16 h-16 rounded-full animate-spin"></div>
          
        </div>
      ) : (
        <div className="text-lg font-bold text-red-600">{text}</div>
      )}
    </div>
  );
};

export default LoadingCounter;
